export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, context) => {
        console.error('Error handler invoked');
        console.error(error, context);
    };

    nuxtApp.hook('vue:error', (error) => {
        console.error('Error handler invoked in vue:error hook');
        console.error(error);
    });

    nuxtApp.hook('apollo:error', (error) => {
        console.error('Error handler invoked in apollo:error hook');
        console.error(error);
    });
});
